import { useContext } from "react";
import { useFormContext, useFormState } from "react-hook-form";
import { TestContext } from "../../../store/testContext";
import { toggleQuestionFormOpen } from "../../../store/testActions";
import TGButton from "src/components/ui/TGButton";
import { IAnswer } from "../../../types";

export default function FormAddQuestionFooter() {
  const { dispatch } = useContext(TestContext);
  const { isValid } = useFormState();

  const { getValues } = useFormContext();

  const handleClickCancel = () => {
    dispatch(toggleQuestionFormOpen(false));
  };

  const disabledButton =
    !isValid ||
    getValues("Answers").length < 2 ||
    !getValues("Answers")?.filter((answer: IAnswer) => answer.IsCorrect).length;

  return (
    <div className="flex justify-between gap-5">
      <TGButton onClick={handleClickCancel} className="w-1/2">
        Отмена
      </TGButton>
      <TGButton type="submit" disabled={disabledButton} className="w-1/2" color="bluedark">
        Сохранить вопрос
      </TGButton>
    </div>
  );
}
